/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import SchemeService from '../../../../services/SchemeService';
import moment from "moment";
import ToastService from '../../../../services/ToastService';
import { showLoading } from 'react-global-loading';
import schemeicoSvg from '../../../../public/mscheme.svg';
import MasterService from '../../../../services/MasterService';
class MissionAllSchemes extends React.Component {
  constructor(props) {
    super(props);
    const url = new URL(window.location);
    showLoading(true);
    this.state = {
      scheme: '',
      schemeModal: '',
      schemes: [], filteredList: [], categories: [], selectedCategory: '',
      showModal: false, schemeType: 1, approved: [], pending: [], currentPage: url.searchParams.get('page') ? parseInt(url.searchParams.get('page')) : 1,
      statusCount: {}, statusType: 1
    };
  }

  componentDidMount = () => {
    // if (this.state.currentPage > 1) {

    //   for (let i = 1; i <= this.state.currentPage; i++) {
    //     this.getAllSchemes(i, this.state.statusType);
    //   }
    // }
    // else this.getAllSchemes(this.state.currentPage, this.state.statusType);
    this.getCategories();
    this.filterdata()
  };

  getCategories = () => {
    MasterService.getCategories()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ categories: result });
      })
      .catch((err) => {

        console.error(err);
      });
  };


  getAllSchemes = (query) => {
    showLoading(true);
    SchemeService.getAllSchemes(query)
      .then((result) => {
        if (!result) return;

        this.setState(
          {
            statusCount: result,
            filteredList: result.data
          }
        );
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  filterdata = (cat) => {

    const url = new URL(window.location);
    cat ? url.searchParams.set('cat', cat) : url.searchParams.delete('cat')

    url.searchParams.delete('page')
    this.setState({ currentPage: 1 })
    let query = {};
    this.setState({ query })
    cat && (query.category = cat);

    this.getAllSchemes(query)
    window.history.pushState(null, '', url.toString());

  }

  onShowModal = (item) => {

    this.setState({ schemeModal: item });
  };

  onLoad = () => {
    let query = {};
    const url = new URL(window.location);
    this.setState({ currentPage: parseInt(this.state.currentPage) + 1 })
    url.searchParams.set('page', this.state.currentPage + 1);
    query.page = url.searchParams.get('page')
    url.searchParams.get('cat') ? (query.category = this.state.selectedCategory) : ''

    this.getAllSchemes(query);


    window.history.pushState(null, '', url.toString());

  }

  onDocApproval = (status) => {
    var data = {
      "ID": this.state.schemeModal.ID,
      "post_status": status,
      "blog_id": this.state.schemeModal.country?.id
    };

    SchemeService.updateStatus(data).then((result) => {

      result.data === 200 ? (
        ToastService.success(result.data.message),
        window.location.reload(false)) :
        (ToastService.error(result.data.message), window.location.reload(false));

    });
  };


  eventType = (type) => {
    let filteredList = [];
    this.setState({ statusType: type });
    const url = new URL(window.location);
    window.history.pushState(null, '', url.toString());
    this.getAllSchemes({ 'type': type });
    this.setState({ filteredList });

  };

  render() {
    const { schemes, scheme, statusType, statusCount, filteredList, pending, approved, schemeModal, categories, selectedCategory, data } = this.state;
    const finalList = filteredList.length > 0 ? filteredList : schemes;
    let fullyLoaded;
    switch (statusType) {
      case 1://all
        fullyLoaded = filteredList.length === statusCount.total ? true : false;
        break;
      case 2://pending
        fullyLoaded = filteredList.length === statusCount.pending ? true : false;
        break;
      case 3://approved
        fullyLoaded = filteredList.length === statusCount.approved ? true : false;
        break;
    }
    return (
      <div className="container pt-2 pmloginscrn">
        {/* <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Mission Schemes</li>
          </ol>
        </nav> */}
        <div className="row bg-light p-2 mt-5 mb-3 rounded rounded-2 d-flex align-items-center justify-content-center m-ver-col">
          <div className="col-md-10 head-title">
            <h4 className="t0">Mission Schemes</h4>
          </div>
          <div className="col-md-2 text-end">
            <a href="/add-schemes" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn">
              {/* <i className="fa fa-plus-circle" aria-hidden="true"></i>  */}
              Create Schemes
            </a>
          </div>
          <hr className="mt-4 mb-4"></hr>
          <div className="col-12">
            <div className="row">
              <span className="text-dark d-block mb-2">
                <i className="fa fa-filter" aria-hidden="true" /> Filter Schemes
              </span>

              <div className="col-4 m-filter-col">
                <div className="form-group mb-4 position-relative">
                  <select name='orderby' className='form-control' aria-label='Shop order' value={selectedCategory}
                    onChange={(e) => (this.setState({ selectedCategory: e.target.value }), this.filterdata(e.target.value))}>
                    <option defaultValue='selected' value=''> Search By Domain</option>
                    {categories?.map((item, index) => <option key={index} value={item.name}>{item.name}</option>)}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row bg-light p-2 mt-5 mb-3 rounded rounded-2 mtless">
          <div className="row mt-3">
            <div className="col-12">
              <ul className="nav nav-tabs admintabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="view-all-documents-tab" onClick={() => this.eventType(1)} data-bs-toggle="tab" type="button" role="tab" aria-selected="true">All <span className="badge text-bg-secondary rounded-circle">{statusCount.total}</span></button>
                </li>
                <li className="nav-item" role="presentation">
                  <button onClick={() => this.eventType(3)} className="nav-link" data-bs-toggle="tab" type="button" role="tab" aria-selected="false"> Approved <span className="badge text-bg-secondary rounded-circle">{statusCount.approved}</span></button>
                </li>
                <li className="nav-item" role="presentation">
                  <button onClick={() => this.eventType(2)} className="nav-link" data-bs-toggle="tab" type="button" role="tab" aria-selected="false">Pending <span className="badge text-bg-secondary rounded-circle">{statusCount.pending}</span></button>
                </li>
              </ul>
              <div className="tab-content bg-white pt-4 px-4 mt-4" >
                <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="#allschemes">

                  <div className="row">
                    <div className=" mt-2">
                      <div className="row view-group">
                        {
                          filteredList.length > 0 ?
                            filteredList.map((item, index) =>

                              <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-3" data-bs-toggle="modal" data-bs-target="#docapproval" onClick={() => this.onShowModal(item)}  >
                                <div className="card p-2 event-card crdev">
                                  <div className="imgrel">
                                    <img src={require('../../../../public/pdf_view-all.png')} className=" card-img-top rounded" alt="events" style={{ width: '50px', objectFit: 'cover' }} />
                                  </div>
                                  <div className="evtxcn px-0 dctx">
                                    <h4 className="evh">
                                      <span className="evhd crop-text" >{item.post_title}</span>
                                    </h4>
                                    <p className="evdes_nw">{item.post_content}</p>
                                    <div className="domls">
                                      {/* <p className="blt">{`Domains  -`}</p> */}
                                      {item.category.map((cat, index) => <div className="domaincell">
                                        {cat.name}
                                      </div>)}
                                      {/* <div className="domaincell">
                                      Siddha
                                    </div>
                                    <div className="domaincell">
                                      Unani
                                    </div> */}
                                    </div>
                                  </div>
                                </div>
                                <div className="crbotm">
                                  <p className="dtpr">Created - <span className="cdte">{moment(item.post_date).format("Do MMM YYYY")}</span></p>
                                  {/* <span className="dtpr">/</span> */}
                                  {/* <p className="dtpr">{` Approved - `}<span className="cdte">24th october 2024</span></p> */}
                                </div>
                              </div>
                            ) : <span>No Schemes found</span>}
                        {fullyLoaded ? <span> </span> : <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            style={{
                              backgroundColor: "#beeadc",
                              border: "none",
                              borderRadius: "10px",
                              padding: "10px 2rem",
                              fontWeight: "semibold",
                            }}
                            onClick={e => this.onLoad()}
                          >
                            Load More
                          </button>
                        </div>}

                      </div>
                    </div>
                  </div>

                </div>

                {/* <div className="tab-pane fade" role="tabpanel" aria-labelledby="all-pendingapprove-documents">
                  <div className="row mt-4">
                    <div className="col-md-10">
                      <div className="head-title">
                        <h4>All Pending Schemes</h4>
                      </div>
                    </div>
                  </div>

                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* ---------------- Document Approval Popup ---------------- */}
        <div className="modal fade" id="docapproval" tabIndex="-1" aria-labelledby="docapprovalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="docapprovalLabel">Scheme Details</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 p-3 mb-4 docvwtop">
                    <h5 className="crop-text dctx">{schemeModal.post_title}</h5>
                    <p className="crop-text dctx">{schemeModal.post_content}</p>
                    <div className="row apdprow">
                      <div className="mb-3 flga">
                        <b className="ml-15">Uploaded on -</b> <span>{moment(schemeModal.post_date).format("Do MMM YYYY")}</span>
                      </div>
                      <div className="text-start mob-btn-col docbtn">
                        {schemeModal.post_status === 'pending' ? <button type="button" className="btn theme-btn-fill btndbg pd-tb-675em border-2" onClick={() => this.onDocApproval('publish')}>Approve</button> :
                          <button type="button" className="btn theme-btn-outline pd-tb-675em border-2 ms-3" onClick={() => this.onDocApproval('pending')}>Disapprove</button>}
                      </div>
                    </div>
                  </div>
                </div >
                <div className="row mt-2 pdfht" aria-labelledby="#label1">
                  <object
                    id="#label1"
                    width="100%"
                    height="100%"
                    type="application/pdf"
                    data={schemeModal.scheme_upload}
                  />
                </div>
              </div >
            </div >
          </div >
        </div >
        {/* ---------------- Document Approval Popup End ---------------- */}

      </div>
    );
  }
}

export default MissionAllSchemes;